module.exports = __webpack_public_path__ + "img/full4-min.c62b98a6.png";